import React, { useEffect } from 'react';
import AOS from 'aos'; // AOS লাইব্রেরি npm থেকে ইম্পোর্ট করা হয়েছে
import 'aos/dist/aos.css'; // AOS CSS npm থেকে ইম্পোর্ট করা হয়েছে
import AppConfig from '../config/appConfig'; // path আপনার ফোল্ডার স্ট্রাকচার অনুযায়ী ঠিক করুন

// প্রধান PrivacyPolicy কম্পোনেন্ট
const PrivacyPolicy = () => {
  useEffect(() => {
    // AOS ইনিশিয়ালাইজ করুন যখন কম্পোনেন্ট মাউন্ট হয়।
    AOS.init({
      duration: 1000, // অ্যানিমেশনের সময়কাল (মিলিসেকেন্ডে)
      once: true,     // অ্যানিমেশন শুধুমাত্র একবার হবে যখন স্ক্রল করা হবে
    });
  }, []);

  return (
    <div className="min-h-screen font-inter text-gray-800 p-4 sm:p-8">
      {/* Tailwind CSS CDN লোড করার জন্য স্ক্রিপ্ট */}
      <script src="https://cdn.tailwindcss.com"></script>
      {/* AOS CSS এবং JS CDN লোড করার জন্য স্ক্রিপ্টগুলি npm ইম্পোর্ট দ্বারা প্রতিস্থাপিত হয়েছে */}

      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-xl p-6 sm:p-10">
        <h1
          className="text-3xl sm:text-4xl font-bold text-center text-indigo-700 mb-8"
          data-aos="fade-down"
        >
          {AppConfig.CompanyName} প্রাইভেসি পলিসি
        </h1>

        {/* পরিচিতি সেকশন */}
        <section className="mb-8" data-aos="fade-up">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-4">১. পরিচিতি</h2>
          <p className="text-gray-700 leading-relaxed">
            {AppConfig.CompanyName}-এ, আপনার গোপনীয়তা আমাদের কাছে অত্যন্ত গুরুত্বপূর্ণ। এই প্রাইভেসি পলিসি ব্যাখ্যা করে যে আমরা কীভাবে আপনার ব্যক্তিগত তথ্য সংগ্রহ করি, ব্যবহার করি, প্রকাশ করি এবং সুরক্ষিত রাখি যখন आপনি आमादेर ओय়ेবসाइট भिजिट करেन बा आमादेर परिषेवागुलि ब्यवहार करেन।
          </p>
          <p className="text-gray-700 leading-relaxed mt-2">
            আমাদের ওয়েবসাইট ব্যবহার করে, আপনি এই প্রাইভেসি পলিসির শর্তাবলীতে সম্মত হন।
          </p>
        </section>

        {/* আমরা যে তথ্য সংগ্রহ করি সেকশন */}
        <section className="mb-8" data-aos="fade-up" data-aos-delay="100">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-4">২. আমরা যে তথ্য সংগ্রহ করি</h2>
          <p className="text-gray-700 leading-relaxed">
            আমরা আপনার কাছ থেকে বিভিন্ন ধরণের তথ্য সংগ্রহ করতে পারি, যার মধ্যে রয়েছে:
          </p>
          <ul className="list-disc list-inside text-gray-700 ml-4 mt-2 space-y-2">
            <li>
              <span className="font-medium">ব্যক্তিগত সনাক্তকরণ তথ্য:</span> নাম, ইমেল ঠিকানা, ডাক ঠিকানা, ফোন নম্বর, এবং পেমেন্টের তথ্য (যেমন ক্রেডিট কার্ড নম্বর)।
            </li>
            <li>
              <span className="font-medium">অর্ডার তথ্য:</span> আপনি যে পণ্যগুলি ক্রয় করেন, অর্ডারের ইতিহাস, এবং শিপিং বিবরণ।
            </li>
            <li>
              <span className="font-medium">ব্যবহারের তথ্য:</span> আপনি কীভাবে আমাদের ওয়েবসাইট ব্যবহার করেন, যেমন ব্রাউজিং প্যাটার্ন, আইপি ঠিকানা, ব্রাউজারের ধরন, ভিজিটের সময়কাল, এবং রেফারেল ইউআরএল।
            </li>
            <li>
              <span className="font-medium">কুকিজ এবং ট্র্যাকিং প্রযুক্তি:</span> আমরা কুকিজ, ওয়েব বীকন এবং অন্যান্য ট্র্যাকিং প্রযুক্তি ব্যবহার করি আপনার অভিজ্ঞতা উন্নত করতে এবং আমাদের ওয়েবসাইটের ব্যবহার বিশ্লেষণ করতে।
            </li>
          </ul>
        </section>

        {/* আমরা কীভাবে আপনার তথ্য ব্যবহার করি সেকশন */}
        <section className="mb-8" data-aos="fade-up" data-aos-delay="200">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-4">৩. আমরা কীভাবে আপনার তথ্য ব্যবহার করি</h2>
          <p className="text-gray-700 leading-relaxed">
            আমরা আপনার সংগৃহীত তথ্য নিম্নলিখিত উদ্দেশ্যে ব্যবহার করি:
          </p>
          <ul className="list-disc list-inside text-gray-700 ml-4 mt-2 space-y-2">
            <li>আপনার অর্ডার প্রক্রিয়া এবং সরবরাহ করতে।</li>
            <li>আপনার অ্যাকাউন্ট পরিচালনা এবং আপনার সাথে যোগাযোগ করতে।</li>
            <li>আমাদের পণ্য এবং পরিষেবা উন্নত করতে।</li>
            <li>আপনার ব্রাউজিং অভিজ্ঞতা ব্যক্তিগতকৃত করতে।</li>
            <li>মার্কেটিং এবং প্রচারমূলক যোগাযোগ পাঠাতে (যদি আপনি সম্মতি দেন)।</li>
            <li>আমাদের ওয়েবসাইটের নিরাপত্তা বজায় রাখতে এবং জালিয়াতি প্রতিরোধ করতে।</li>
            <li>আইনি বাধ্যবাধকতা মেনে চলতে।</li>
          </ul>
        </section>

        {/* ডেটা নিরাপত্তা সেকশন */}
        <section className="mb-8" data-aos="fade-up" data-aos-delay="300">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-4">৪. ডেটা নিরাপত্তা</h2>
          <p className="text-gray-700 leading-relaxed">
            আমরা আপনার ব্যক্তিগত তথ্য অননুমোদিত অ্যাক্সেস, ব্যবহার বা প্রকাশের হাত থেকে রক্ষা করার জন্য যুক্তিসঙ্গত নিরাপত্তা ব্যবস্থা গ্রহণ করি। এর মধ্যে রয়েছে এনক্রিপশন, ফায়ারওয়াল এবং সুরক্ষিত সার্ভার। তবে, ইন্টারনেটের মাধ্যমে ডেটা ট্রান্সমিশনের কোনো পদ্ধতিই ১০০% সুরক্ষিত নয়।
          </p>
        </section>

        {/* আপনার অধিকার সেকশন */}
        <section className="mb-8" data-aos="fade-up" data-aos-delay="400">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-4">৫. আপনার অধিকার</h2>
          <p className="text-gray-700 leading-relaxed">
            আপনার ব্যক্তিগত তথ্য সম্পর্কিত নিম্নলিখিত অধিকারগুলি রয়েছে:
          </p>
          <ul className="list-disc list-inside text-gray-700 ml-4 mt-2 space-y-2">
            <li>
              <span className="font-medium">অ্যাক্সেসের অধিকার:</span> আপনার সম্পর্কে আমাদের কাছে থাকা ব্যক্তিগত তথ্যের একটি কপি অনুরোধ করার অধিকার।
            </li>
            <li>
              <span className="font-medium">সংশোধনের অধিকার:</span> ভুল বা অসম্পূর্ণ তথ্য সংশোধন করার অনুরোধ করার অধিকার।
            </li>
            <li>
              <span className="font-medium">মুছে ফেলার অধিকার:</span> কিছু নির্দিষ্ট পরিস্থিতিতে আপনার ব্যক্তিগত তথ্য মুছে ফেলার অনুরোধ করার অধিকার।
            </li>
            <li>
              <span className="font-medium">প্রক্রিয়াকরণ সীমিত করার অধিকার:</span> কিছু নির্দিষ্ট পরিস্থিতিতে আপনার তথ্যের প্রক্রিয়াকরণ সীমিত করার অনুরোধ করার অধিকার।
            </li>
            <li>
              <span className="font-medium">ডেটা পোর্টেবিলিটির অধিকার:</span> আপনার তথ্য অন্য প্রতিষ্ঠানে স্থানান্তরিত করার অনুরোধ করার অধিকার।
            </li>
            <li>
              <span className="font-medium">আপত্তি জানানোর অধিকার:</span> আপনার ব্যক্তিগত তথ্যের প্রক্রিয়াকরণে আপত্তি জানানোর অধিকার।
            </li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-2">
            এই অধিকারগুলি প্রয়োগ করতে, অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন।
          </p>
        </section>

        {/* তৃতীয় পক্ষের লিঙ্ক সেকশন */}
        <section className="mb-8" data-aos="fade-up" data-aos-delay="500">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-4">৬. তৃতীয় পক্ষের লিঙ্ক</h2>
          <p className="text-gray-700 leading-relaxed">
            আমাদের ওয়েবসাইটে তৃতীয় পক্ষের ওয়েবসাইটগুলির লিঙ্ক থাকতে পারে। এই লিঙ্কযুক্ত সাইটগুলির গোপনীয়তা অনুশীলন আমাদের নিয়ন্ত্রণে নেই। আমরা আপনাকে প্রতিটি ভিজিট করা ওয়েবসাইটের প্রাইভেসি পলিসি পর্যালোচনা করার জন্য উৎসাহিত করি।
          </p>
        </section>

        {/* এই পলিসিতে পরিবর্তন সেকশন */}
        <section className="mb-8" data-aos="fade-up" data-aos-delay="600">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-4">৭. এই পলিসিতে পরিবর্তন</h2>
          <p className="text-gray-700 leading-relaxed">
            আমরা সময় সময় এই প্রাইভেসি পলিসি আপডেট করতে পারি। কোনো পরিবর্তন কার্যকর হওয়ার সাথে সাথে এই পৃষ্ঠায় পোস্ট করা হবে। আমরা আপনাকে পর্যায়ক্রমে এই পলিসি পর্যালোচনা করার জন্য উৎসাহিত করি।
          </p>
        </section>

        {/* আমাদের সাথে যোগাযোগ করুন সেকশন */}
        <section data-aos="fade-up" data-aos-delay="700">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-4">৮. আমাদের সাথে যোগাযোগ করুন</h2>
          <p className="text-gray-700 leading-relaxed">
            এই প্রাইভেসি পলিসি সম্পর্কে আপনার কোনো প্রশ্ন বা উদ্বেগ থাকলে, অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন:
          </p>
          <ul className="list-disc list-inside text-gray-700 ml-4 mt-2 space-y-2">
            <li>
              <span className="font-medium">ইমেল:</span> <a href={`mailto:${AppConfig.contactEmail}`} className="underline">{AppConfig.contactEmail}</a>
            </li>
            <li>
              <span className="font-medium">ঠিকানা:</span> মধুবাগ, মগবাজার, ঢাকা, বাংলাদেশ
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
